export const ssoFormTypes = {
    OneClubRegister: 0,
    DefaultRegister: 1,
    TicketingRegister: 2,
    UpgradeToTicketingAccount: 3,
    UpgradeToOneClubAccountFromDefault: 4,
    SignIn: 5,
    NewPasswordRequired: 6,
    ForgotPassword: 7,
    ResetPassword: 8,
    OneClubRegisterSuccess: 9,
    UserAccount: 10,
    VerifyEmail: 11,
    UpgradeToOneClubAccountFromTicketing: 12,
    BallotLiteRegister: 13,
    BallotFullRegister: 14,
    BallotSummaryForm: 15,
    BallotSignInForm: 16,
    BallotSignInSuccessForm: 17,
    SignInSuccess: 18,
    BallotForgotPassword: 19,
    SSOItemListForm: 24,
    PreRegisterForm: 25
};
